import { subscribeToPriceChange } from '../../core/store/checkoutFetch';
import { asPaymentErrorSource, type PaymentErrorSource } from './errors';

export type StripePaymentStartResult =
  | { kind: 'redirect'; clientSecret: string }
  | {
      kind: 'completed';
      subscriptionId: string;
      eventId: string;
      customerId?: string | number;
    }
  | {
      kind: 'failed';
      message: string;
      errorData?: PaymentErrorSource;
      paymentData?: PaymentErrorSource;
    };

type StripePaymentStartMessages = {
  couldNotStart: string;
  paymentFailed: string;
};

export const resolveStripePaymentStart = async (
  initialResponse: Record<string, unknown>,
  messages: StripePaymentStartMessages,
): Promise<StripePaymentStartResult> => {
  const subscriptionId = initialResponse.subscription_id;
  if (typeof subscriptionId === 'string' && subscriptionId) {
    const customerId = initialResponse.customer_id;

    return {
      kind: 'completed',
      subscriptionId,
      eventId: typeof initialResponse.event_id === 'string' ? initialResponse.event_id : '',
      customerId:
        typeof customerId === 'string' || typeof customerId === 'number' ? customerId : undefined,
    };
  }

  const clientSecret = initialResponse.payment_intent_secret;
  if (typeof clientSecret === 'string' && clientSecret) {
    return { kind: 'redirect', clientSecret };
  }

  const pollingId = initialResponse.polling_result_id;
  if (typeof pollingId !== 'string' || !pollingId) {
    return { kind: 'failed', message: messages.couldNotStart };
  }

  const pollingResult = await subscribeToPriceChange(pollingId);
  if (pollingResult?.status === 'requires_action' && pollingResult.data?.payment_intent_secret) {
    return {
      kind: 'redirect',
      clientSecret: pollingResult.data.payment_intent_secret,
    };
  }

  if (pollingResult?.status && pollingResult.data?.subscription_id) {
    return {
      kind: 'completed',
      subscriptionId: pollingResult.data.subscription_id,
      eventId: pollingResult.data.event_id || '',
      customerId: pollingResult.data.customer_id,
    };
  }

  return {
    kind: 'failed',
    message: pollingResult?.errors?.messages || messages.paymentFailed,
    errorData: asPaymentErrorSource(pollingResult?.errors),
    paymentData: asPaymentErrorSource(pollingResult?.data),
  };
};
